export default __webpack_public_path__ + "static/media/State Farm.f2d638de.svg";